// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1tmcH","title":"ClientReferral_title__2mLz5","itemText":"ClientReferral_itemText__2V8bg"};